/* eslint-disable no-debugger */
import { useEffect } from 'react';

// import useOfficialMentorLevelData from '../../../state/officialMentorLevel/UseOfficialMentorLevelData';
import useOrgUnitData from '../../../state/orgUnit/UseOrgUnitData';

const useOrgUnitDropdown = (reportInfoId) => {
  const { orgUnitState, getOrgUnitByCurrentPerson } = useOrgUnitData();

  useEffect(() => {
    if (orgUnitState?.isArrayLoading !== true && orgUnitState?.isArrayLoaded !== true) {
      getOrgUnitByCurrentPerson(reportInfoId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orgUnitState, reportInfoId]);
  return {
    orgUnitState
  };
};

export default useOrgUnitDropdown;